import _ from 'lodash';

/**
 * @param {object} toCompare Object compared
 * @param {object} comparedWith  Object to compare with
 * @returns Returns a new object who represent the diff
 */
export default function getDifferenceBetweenObjects(toCompare, comparedWith) {
  const changes = (object, base) => {
    return _.transform(object, (result, value, key) => {
      if (!_.isEqual(value, base[key])) {
        // eslint-disable-next-line no-param-reassign
        result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  };
  return changes(toCompare, comparedWith);
}
